import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SideNavigationItem } from '../../atlas_sdk/api';

import { BusinessNavConfigService, Config } from '../../config.service';
import { AtlasTranslateService } from '../../translate/translate.service';
import { replaceUrlTokens } from '../util';

@Component({
  selector: 'atlas-nav-item-container',
  templateUrl: './nav-item-container.component.html',
  styleUrls: ['./nav-item-container.component.scss']
})
export class NavItemContainerComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  @Input() icon: string;
  @Input() label: string;
  @Input() translationId: string;
  @Input() logoUrl: string;
  @Input() productId: string;
  @Input() productName: string;
  @Input() indentation: number;
  @Input() showIcon: boolean;
  @Input() children: SideNavigationItem[];
  @Input() chipContent: string;
  @ViewChild('container', { static: true }) container: ElementRef;
  text$: Observable<string>;

  private opened$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public opened$: Observable<boolean> = this.opened$$.asObservable();
  private subs: Subscription[] = [];

  constructor(private renderer: Renderer2, private t: AtlasTranslateService,
              private router: Router, private configService: BusinessNavConfigService) {
  }

  get containerHeight(): number {
    return this.container.nativeElement.offsetHeight;
  }

  ngOnInit(): void {
    this.text$ = this.t.stream(this.translationId, this.label);
  }

  ngOnDestroy(): void {
    this.subs.map((sub: Subscription) => sub.unsubscribe());
  }

  public toggle(): void {
    const toggledValue = !this.opened$$.getValue();
    this.updateRendererStyle(toggledValue);
    this.opened$$.next(toggledValue);
  }

  public open(): void {
    if (this.opened$$.getValue()) {
      return;
    }
    this.updateRendererStyle(true);
    this.opened$$.next(true);
  }

  updateRendererStyle(open: boolean): void {
    if (open) {
      this.renderer.setStyle(this.container.nativeElement, 'margin-top', '0');
    } else {
      this.renderer.setStyle(this.container.nativeElement, 'margin-top', -this.containerHeight + 'px');
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateRendererStyle(this.opened$$.getValue()), 0);
  }

  ngAfterContentInit(): void {
    const config = this.configService.getCurrentConfig();
    if (this.checkChildrenForActiveRoute(this.children, config)) {
      this.open();
    }
  }

  private checkChildrenForActiveRoute(children: SideNavigationItem[], config: Config): boolean {
    let active = false;
    if (!children || children.length === 0) {
      return active;
    }

    const curPath = `/${this.router.parseUrl(this.router.url).root.children.primary.toString()}`;

    for (const child of children) {
      if (!!child.sideNavigationSection) {
        active = this.checkChildrenForActiveRoute(child.sideNavigationSection.sideNavigationItems, config);
      } else if (!!child.sideNavigationContainer) {
        active = this.checkChildrenForActiveRoute(child.sideNavigationContainer.sideNavigationItems, config);
      } else if (child.sideNavigationLink.serviceProviderId === config.serviceProviderId) {
        active = curPath === replaceUrlTokens(child.sideNavigationLink.path, config.accountId, config.groupPath);
      }

      if (active) {
        break;
      }
    }

    return active;
  }
}
